import { powerSyncCollectionOptions } from "@tanstack/powersync-db-collection";
import { createCollection } from "@tanstack/react-db";
import { z } from "zod";
import { AppSchema } from "@/lib/powersync-schema.generated";
import { collectionBase } from "./_factory";
import { syncedRow } from "./synced-row";

export const SelectReservationUnitGuestSchema = syncedRow({
  // Null until the guest is checked in (ADR-0146).
  checkInId: z.string().nullable(),
  createdAt: z.string(),
  guestId: z.string(),
  id: z.string(),
  propertyId: z.string(),
  reservationUnitId: z.string(),
  updatedAt: z.string(),
});

export type ReservationUnitGuest = z.infer<
  typeof SelectReservationUnitGuestSchema
>;

export const reservationUnitGuestsCollection = createCollection(
  powerSyncCollectionOptions({
    ...collectionBase("reservation unit guest"),
    schema: SelectReservationUnitGuestSchema,
    table: AppSchema.props.reservation_unit_guests,
  })
);
